const WHITE_FILTER = 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(313deg) brightness(107%) contrast(105%)';
const ORANGE_FILTER = 'brightness(0) saturate(100%) invert(62%) sepia(53%) saturate(1312%) hue-rotate(329deg) brightness(96%) contrast(101%)';
const GH_ORANGE_FILTER = 'brightness(0) saturate(100%) invert(55%) sepia(27%) saturate(5502%) hue-rotate(1deg) brightness(103%) contrast(106%);'
const GH_DESIGN = {
  hallPanelMainBackgroundColor: {backgroundColor: 'rgb(228, 228, 228)'},
  hallPanelMainBackgroundClassName: '',
  orderStreamWidgetKeyRadius: "50%",
  orderStreamWidgetFontColor: 'gray',
  ready: 'rgb(76, 184, 134)',
  preparing: 'rgb(250, 174, 29)',
  queued: 'rgba(0, 0, 0, 0.5)',
  empty: 'rgba(0, 0, 0, 0.12)',
  boxedOrderFontColor: "white",
  boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
  backGroundColor: 'rgb(255, 255, 255)',
  closedShopBackgroundColor: 'rgb(86, 90, 92)',
  orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
  orderStreamPanelMainEtaTextColor: "black",
  shopNameColor: "black",
  shopListEtaBoxOpenColor: "rgb(246, 52, 64)",
  shopListEtaBoxClosedColor: 'rgb(0, 0, 0.87)',
  headerLineSplitStyle: '',
  hallPanelCourtTitleColor: 'rgba(0, 0, 0, 0.87)',
  hallPanelLogoFilter: GH_ORANGE_FILTER,
};
const LIVE_ORDER_STREAM_STYLE = {
  vertical: {
    common: {
      widgetFontSize: '.92vh',
      panelHeaderPaddingTop: '1.5%',
      widgetHeight: '100%',
      alertHeight: '0%'
    },
    withAlert: {
      shopClosedWithOpenHours: {
        alertHeight: '55%',
        widgetHeaderMarginTop: '2%',
        panelHeaderPaddingTop: '1%',
        logoRelativeSizeToParent: 0.70,
      },
      default: {
        panelHeight: '25%',
        panelHeaderSplitLineHeight: '3%',
        widgetHeaderHeight: '12%',
        widgetHeaderMarginTop: '3%',
        logoRelativeSizeToParent: 0.60,
        panelHeaderPaddingTop: '1%',
        alertHeight: '40%',
      }
    },
    withoutAlert: {
      panelHeight: '15%',
      panelHeaderSplitLineHeight: '12%',
      widgetHeaderHeight: '15%',
      widgetHeaderMarginTop: '0%',
      logoRelativeSizeToParent: 0.55,
      shopClosedTimeHeight: '7%',
      shopClosedHeaderHeight: '12%',
      shopClosedHoursPaddingBottom: '0%',
    }
  },
  horizontal: {
    common: {
      widgetFontSize: '2vh',
      alertHeight: '0%',
    },
    withAlert: {
      shopClosedWithOpenHours: {
        alertHeight: '45%',
        widgetHeaderMarginTop: '2.5%',
        panelHeaderPaddingTop: '1%',
        logoRelativeSizeToParent: 0.70,
      },
      default: {
        panelHeight: '43.6%',
        panelHeaderPaddingTop: '2%',
        widgetHeight: '56.4%',
        widgetHeaderHeight: '12%',
        widgetHeaderMarginTop: '3.5%',
        panelHeaderSplitLineHeight: '3.5%',
        logoRelativeSizeToParent: 0.60,
        alertHeight: '35%',
      }
    },
    withoutAlert: {
      panelHeight: '23.6%',
      panelHeaderPaddingTop: '1.5%',
      widgetHeight: '76.4%',
      widgetHeaderHeight: '20%',
      widgetHeaderMarginTop: '0%',
      panelHeaderSplitLineHeight: '6.5%',
      logoRelativeSizeToParent: 0.60,
      shopClosedTimeHeight: '10%',
      shopClosedHeaderHeight: '20%',
      shopClosedHoursPaddingBottom: '3%',
    }
  }
}
const SAVED_STYLES_COLLECTION = {
 default_light: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(255, 255, 255)'},
    hallPanelMainBackgroundClassName: 'americanFallbackPatternLight',
    hallPanelShopName: {margin: 'auto', color: 'rgb(38, 38, 50)', fontWeight: 'lighter'},
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'rgb(84, 84, 112)',
    ready: 'rgb(14, 132, 80)',
    preparing: 'rgb(250, 174, 29)',
    queued: 'rgb(143, 143, 161)',
    empty: 'rgb(239, 239, 242)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(255, 255, 255)',
    closedShopBackgroundColor: 'rgb(255, 255, 255)',
    orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
    orderStreamPanelMainEtaTextColor: "rgb(38, 38, 50)",
    shopNameColor: "rgb(38, 38, 50)",
    shopListEtaBoxOpenColor: "rgb(84, 84, 112)",
    shopListEtaBoxClosedColor: 'rgb(143, 143, 161)',
    headerLineSplitStyle: '',
    hallPanelLogoFilter: 'rgb(255, 128, 0)',
  },
  default_dark: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(0, 0, 0)'},
    hallPanelMainBackgroundClassName: 'americanFallbackPatternDark',
    hallPanelShopName: {margin: 'auto', color: 'rgb(255, 255, 255)', fontWeight: 'lighter'},
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'rgb(255, 255, 255)',
    ready: 'rgb(80, 217, 150)',
    preparing: 'rgb(251, 194, 14)',
    queued: 'rgb(212, 212, 219)',
    empty: 'rgba(255, 255, 255, 0.15)',
    boxedOrderFontColor: "rgb(38, 38, 50)",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(0, 0, 0)',
    closedShopBackgroundColor: 'rgb(0, 0, 0)',
    orderStreamPanelMainEtaBoxColor: "rgb(0, 0, 0)",
    orderStreamPanelMainEtaTextColor: "rgb(255, 255, 255)",
    shopNameColor: "rgb(255, 255, 255)",
    shopListEtaBoxOpenColor: "rgb(84, 84, 112)",
    shopListEtaBoxClosedColor: 'rgb(143, 143, 161)',
    headerLineSplitStyle: '',
    hallPanelLogoFilter: 'rgb(0, 0, 0)',
  },
  starbucks: {
    //do this to use assets as background images, only works through a css file
    hallPanelMainBackgroundClassName: 'starbucksPanelBackgroundImage',
    shopSidePanelHeader: {
      backgroundColor: "rgb(227, 89, 16)",
      boxShadow: "-4px 0px 4px 2px rgba(0,0,0,.42)",
      color: "rgb(0, 0, 0)"
    },
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(0, 120, 82',
    preparing: 'rgb(164, 140, 110)',
    queued: 'rgb(126, 121, 116)',
    empty: 'rgba(0, 0, 0, 0.54)',
    backGroundColor: 'rgba(45, 41, 38, 100)',
    closedShopBackgroundColor: 'rgba(45, 41, 38, 100)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'black',
    mainEtaBoxColor: '',
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: 'rgba(45, 41, 38, 100)',
    shopListEtaBoxClosedColor: 'rgba(45, 41, 38, 100)',
    headerLineSplitStyle: '',

  },
  ebb: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(66, 63, 59)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(236, 171, 33)',
    preparing: 'rgb(194, 163, 132)',
    queued: 'rgb(136, 130, 124)',
    empty: 'rgba(255, 255, 255, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'black',
    backGroundColor: 'rgb(23, 23, 23)',
    closedShopBackgroundColor: 'rgb(23, 23, 23)',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: 'thin solid rgba(255, 255, 255, 0.3)',
    hallPanelLogoFilter: ORANGE_FILTER,
  },
  nrich: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(227, 89, 16)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(167, 195, 83)',
    preparing: 'rgb(105, 111, 47)',
    queued: 'rgb(113, 46, 62)',
    empty: 'rgb(87, 87, 87)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'black',
    backGroundColor: 'rgb(23, 23, 23)',
    closedShopBackgroundColor: 'rgb(23, 23, 23)',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: 'thin solid rgba(255, 255, 255, 0.3)',
  },
  iq: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(227, 89, 16)'},
    hallPanelMainBackgroundClassName: 'iqFreshPanelBackgroundImage',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(231, 39, 139)',
    preparing: 'rgb(253, 184, 22)',
    queued: 'rgb(87, 87, 87)',
    empty: 'rgba(255, 255, 255, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'black',
    backGroundColor: 'rgb(23, 23, 23)',
    closedShopBackgroundColor: 'rgb(23, 23, 23)',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: 'thin solid rgba(255, 255, 255, 0.3)',
  },
  roost: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(161, 0, 34)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(161, 0, 34)',
    preparing: 'rgb(171, 167, 168)',
    queued: 'rgba(109, 110, 113)',
    empty: 'rgba(0, 0, 0, 0.38)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'black',
    backGroundColor: 'rgb(42, 43, 44)',
    closedShopBackgroundColor: 'rgb(42, 43, 44)',
    orderStreamPanelMainEtaBoxColor: "rgb(42, 43, 44)",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(10, 136, 155)',
    headerLineSplitStyle: 'thin solid rgba(255, 255, 255, 0.3)',
  },
  jambajuice: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(36, 40, 49)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'rgb(87, 39, 0)',
    ready: 'rgb(198, 12, 70)',
    preparing: 'rgb(248, 152, 29)',
    queued: 'rgba(193, 215, 47)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: 'white',
    boxedOrderBorderColor: 'white',
    backGroundColor: 'white',
    closedShopBackgroundColor: 'white',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "rgb(87, 39, 0)",
    shopNameColor: "rgb(87, 39, 0)",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(10, 136, 155)',
    headerLineSplitStyle: 'thin solid rgba(232, 232, 232)',
    shopCurrentlyClosedText: 'rgb(198, 12, 70)',
    closedHoursTextColor: 'rgb(87, 39, 0)'
  },
  pandaexpress: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(206, 18, 61)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(148, 195, 85)',
    preparing: 'rgb(241, 153, 51)',
    queued: 'rgba(115, 117, 120)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: 'white',
    boxedOrderBorderColor: 'rgb(45, 42, 38)',
    backGroundColor: 'rgb(45, 42, 38)',
    closedShopBackgroundColor: 'rgb(45, 42, 38)',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(10, 136, 155)',
    headerLineSplitStyle: 'thin solid rgba(232, 232, 232)',
  },
  sabor: {
    hallPanelMainBackgroundColor: {backgroundColor: 'black'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "15px",
    orderStreamWidgetFontColor: 'rgba(0, 0, 0, 0.87)',
    ready: 'rgb(228, 159, 22)',
    preparing: 'rgb(56, 34, 37)',
    queued: 'rgba(115, 117, 120)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: 'white',
    boxedOrderBorderColor: 'white',
    backGroundColor: 'white',
    closedShopBackgroundColor: 'white',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "rgba(0, 0, 0, 0.87)",
    shopNameColor: "rgba(0, 0, 0, 0.87)",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(10, 136, 155)',
    headerLineSplitStyle: 'thin solid rgba(232, 232, 232)',
    shopCurrentlyClosedText: 'rgb(56, 34, 37)',
    closedHoursTextColor: 'rgb(56, 34, 37)'
  },
  bageltalk: {
    hallPanelMainBackgroundColor: {backgroundColor: 'black'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "15px",
    orderStreamWidgetFontColor: 'rgba(0, 0, 0, 0.87)',
    ready: 'rgb(235, 124, 0)',
    preparing: 'rgb(69, 34, 0)',
    queued: 'rgba(115, 117, 120)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: 'white',
    boxedOrderBorderColor: 'white',
    backGroundColor: 'white',
    closedShopBackgroundColor: 'white',
    orderStreamPanelMainEtaBoxColor: "",
    orderStreamPanelMainEtaTextColor: "rgb(87, 39, 0)",
    shopNameColor: "rgba(0, 0, 0, 0.87)",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(10, 136, 155)',
    headerLineSplitStyle: 'thin solid rgba(232, 232, 232)',
    shopCurrentlyClosedText: 'rgba(0, 0, 0, 0.87)',
    closedHoursTextColor: 'rgba(0, 0, 0, 0.87)'
  },
  osu: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(187, 0, 0)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: '50%',
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(102, 102, 102)',
    preparing: 'rgb(187, 0, 0)',
    queued: 'rgb(144, 151, 56)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: 'white',
    boxedOrderBorderColor: 'black',
    backGroundColor: 'black',
    closedShopBackgroundColor: 'black',
    orderStreamPanelMainEtaBoxColor: '',
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: 'white',
    shopListEtaBoxOpenColor: 'rgb(10, 136, 155)',
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: 'thin solid rgba(255, 255, 255, 0.3)',
  },
  usf: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(0, 121, 83)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(76, 184, 134)',
    preparing: 'rgb(224, 176, 117)',
    queued: 'rgb(136, 136, 136)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(46, 52, 63)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(46, 52, 63)",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 77, 56)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: '',
    hallPanelCourtTitleColor: 'rgb(209, 255, 54)'
  },
  wcup: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(46, 52, 63)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'white',
    ready: 'rgb(76, 184, 134)',
    preparing: 'rgb(141, 70, 187)',
    queued: 'rgb(136, 136, 136)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(46, 52, 63)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(141, 70, 187)",
    orderStreamPanelMainEtaTextColor: "white",
    shopNameColor: "white",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: '',
  },
  seamless: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(14, 138, 144)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'gray',
    ready: 'rgb(76, 184, 134)',
    preparing: 'rgb(250, 174, 29)',
    queued: 'rgba(0, 0, 0, 0.5)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(255, 255, 255)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
    orderStreamPanelMainEtaTextColor: "black",
    shopNameColor: "black",
    shopListEtaBoxOpenColor: "rgb(23, 69, 69)",
    shopListEtaBoxClosedColor: 'rgb(0, 0, 0.87)',
    headerLineSplitStyle: '',
    hallPanelCourtTitleColor: 'rgb(255, 255, 255)',
    hallPanelLogoFilter: WHITE_FILTER,
  },
  grubhub: {...GH_DESIGN},
  grubhub_reversed: {
    ...GH_DESIGN,
    reversed: true,
    hallPanelMainBackgroundClassName: 'grubhubPanelBackgroundImage',
  },
  DMK: {...GH_DESIGN},
  CFA: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(228, 228, 228)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'gray',
    ready: 'rgb(221, 0, 49)',
    preparing: 'rgba(221, 0, 49, 0.5)',
    queued: 'rgba(91, 103, 112, 0.5)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(255, 255, 255)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
    orderStreamPanelMainEtaTextColor: "black",
    shopNameColor: "black",
    shopListEtaBoxOpenColor: "rgb(246, 52, 64)",
    shopListEtaBoxClosedColor: 'rgb(0, 0, 0.87)',
    headerLineSplitStyle: '',
    hallPanelLogoName: 'grubhubLogo',
    hallPanelCourtTitleColor: 'rgba(0, 0, 0, 0.87)'
  },
  CFA_QR: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(228, 228, 228)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'gray',
    ready: 'rgb(221, 0, 49)',
    preparing: 'rgba(221, 0, 49, 0.5)',
    queued: 'rgba(91, 103, 112, 0.5)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(255, 255, 255)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
    orderStreamPanelMainEtaTextColor: "black",
    shopNameColor: "black",
    shopListEtaBoxOpenColor: "rgb(246, 52, 64)",
    shopListEtaBoxClosedColor: 'rgb(0, 0, 0.87)',
    headerLineSplitStyle: '',
    hallPanelLogoName: 'grubhubLogo',
    hallPanelCourtTitleColor: 'rgba(0, 0, 0, 0.87)'
  },
  VT: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(228, 228, 228)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'gray',
    ready: '#861f41',
    preparing: '#e87722',
    queued: '#75787b',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(255, 255, 255)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
    orderStreamPanelMainEtaTextColor: "black",
    shopNameColor: "black",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: '',
    hallPanelLogoName: 'grubhubLogo',
    hallPanelCourtTitleColor: 'rgba(0, 0, 0, 0.87)'
  },
  MOE: {
    hallPanelMainBackgroundColor: {backgroundColor: 'rgb(228, 228, 228)'},
    hallPanelMainBackgroundClassName: '',
    orderStreamWidgetKeyRadius: "50%",
    orderStreamWidgetFontColor: 'gray',
    ready: 'rgb(52, 194, 208)',
    preparing: 'rgb(224, 71, 39)',
    queued: 'rgb(65, 65, 67)',
    empty: 'rgba(0, 0, 0, 0.12)',
    boxedOrderFontColor: "white",
    boxedOrderBorderColor: 'rgba(0, 0, 0, 0.12)',
    backGroundColor: 'rgb(255, 255, 255)',
    closedShopBackgroundColor: 'rgb(86, 90, 92)',
    orderStreamPanelMainEtaBoxColor: "rgb(255, 255, 255)",
    orderStreamPanelMainEtaTextColor: "black",
    shopNameColor: "black",
    shopListEtaBoxOpenColor: "rgb(10, 136, 155)",
    shopListEtaBoxClosedColor: 'rgb(57, 61, 63)',
    headerLineSplitStyle: '',
    hallPanelLogoName: 'grubhubLogo',
    hallPanelCourtTitleColor: 'rgba(0, 0, 0, 0.87)'
  }
};

const DesignType = {
    DEFAULT: "default2",
    CFA: "CFA",
    CFA_QR: "CFA_QR",
    VT: "VT",
    DEFAULT_DARK: "default_dark",
    DEFAULT_LIGHT: "default_light",
    EBB: "ebb",
    GRUBHUB_REVERSED: "grubhub_reversed",
    IQ: "iq",
    OSU: "osu",
    SEAMLESS: "seamless",
    USF: "usf",
    WCUP: "wcup",
    CHECK_IN_QR_AND_CODE: "check_in_qr_and_code",
    CHECK_IN_QR_AND_CODE_AND_TAP: "check_in_qr_and_code_and_tap"
}

SAVED_STYLES_COLLECTION[DesignType.CHECK_IN_QR_AND_CODE] = SAVED_STYLES_COLLECTION['default_light']
SAVED_STYLES_COLLECTION[DesignType.CHECK_IN_QR_AND_CODE_AND_TAP] = SAVED_STYLES_COLLECTION['default_light']

const GraphikFont = {
  BOLD: "GraphikBold",
  SEMI_BOLD: "GraphikSemiBold",
  MEDIUM: "GraphikMedium",
  REGULAR: "GraphikRegular",
  LIGHT: "GraphikLight",
}

module.exports = {
  LIVE_ORDER_STREAM_STYLE,
  SAVED_STYLES_COLLECTION,
  DesignType,
  GraphikFont,
}



// WEBPACK FOOTER //
// ./src/constants/Designs.js